import { Injectable } from '@angular/core';
import {URLSearchParams, Http} from "@angular/http";
import {Observable} from  "rxjs/Observable";
import {HttpService} from "./http-service";
import {LoadingService} from "./loading-service";
import {AuthStore} from '../stores/auth-store';
import 'rxjs/add/operator/map';

/*
  Generated class for the AuthService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class AuthService extends HttpService {

  constructor(protected http: Http, protected loadingService:LoadingService, protected authStore:AuthStore) {
    super(http, loadingService, authStore);
  }

  /**
   * 認証処理
   */
  auth(data:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/auth/login");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth-service.ts